<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      snack: false,
    }
  },

  computed: {
    ...mapState('app', ['snackbar']),
  },

  watch: {
    snackbar() {
      this.snack = true
    },
  },
}
</script>

<template>
  <VSnackbar v-model="snack" bottom left>
    {{ snackbar.text }}
    <VBtn dark flat @click="snack = false">
      Close
    </VBtn>
  </VSnackbar>
</template>
